import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home/Home/Home';
import AboutUs from './components/AboutUs/AboutUs';
import Diagnosticians from './components/Diagnosticians/Diagnosticians';
import SignInUp from './components/Login/SignInUp';
import AppointmentPage from './components/Appointment/AppointmentPage';
import ThankYouPage from './components/Appointment/ThankYouPage';
import Offer from './components/Offer/Offer';
import Blog from './components/Blog/Blog';
import Article from './components/Blog/Article';
import PriceList from './components/PriceList/PriceList';
import Regulations from './components/Regulations/Regulations';
import Policies from './components/Policies/Policies';
import TrackAppointment from './components/TrackAppointment/TrackAppointment';
import UserAppointments from './components/UserProfile/UserAppointments';
import EditUserAppointmentData from './components/UserProfile/AppointmentEditUserData';
import Contact from './components/Contact/Contact';
import Specialities from './components/Specialities/Specialities';
import ProfileSettings from './components/UserProfile/ProfileSettings';
import ScrollToTop from './helpers/ScrollToTop';
import ScrollToHashElement from './helpers/ScrollToHashElement';

import { AuthProvider } from "./context/AuthContext";
import { AppointmentsProvider } from "./context/AppointmentsContext";
import ProtectedRoute from './context/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
    <AppointmentsProvider>
      <Router>
        <ScrollToTop />
        <ScrollToHashElement />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/o-nas' element={<AboutUs />} />
          <Route path='/specjalisci' element={<Diagnosticians />} />
          <Route path='/login' element={<SignInUp />} />
          <Route path='/umow-wizyte' element={
            // <ProtectedRoute>
              <AppointmentPage />
            // </ProtectedRoute>
          } />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path='/oferta' element={<Offer />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/cennik' element={<PriceList />} />
          <Route path='/regulamin' element={<Regulations />} />
          <Route path='/rodo-i-polityka-prywatnosci' element={<Policies />} />
          <Route path='/sprawdz-swoje-wizyty' element={
            <ProtectedRoute>
              <TrackAppointment />
            </ProtectedRoute>
          } />
          <Route path='/kontakt' element={<Contact />}/>
          <Route path='/specjalizacje' element={<Specialities />}/>
          <Route path='/dane-uzytkownika' element={
            <ProtectedRoute>
              <ProfileSettings />
            </ProtectedRoute>
          }/>
          <Route path='/twoje-wizyty' element={
            <ProtectedRoute>
              <UserAppointments />
            </ProtectedRoute>
          }/>
          <Route path='/twoje-wizyty/edycja-danych-pacjenta' 
          element={<EditUserAppointmentData />} 
          />
          <Route path="/blog/:slug" element={<Article />} />
        </Routes>
      </Router>
    </AppointmentsProvider>
    </AuthProvider>
  );
}

export default App;
